import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "./UserContext";
import { MainLogo } from "../components/Icons/MainLogo";
import LoadingSpinner from "controls/LoadingSpinner";

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isLoggedIn, authLoading } = useUser();
  const location = useLocation();

if (authLoading || isLoggedIn === null) {
  return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          backgroundColor: "#ffffff",
          gap: "12px",
        }}
      >
        <MainLogo style={{ width: 160 }} />
        <span
          style={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#6b7280", // subtle gray like your site text
            letterSpacing: "0.5px",
          }}
        >
            <LoadingSpinner title="Loading..." />
        </span>
      </div>

  );
}

  if (!isLoggedIn) {
    return (
      <Navigate
        to="/authentication/sign-in"
        replace
        state={{ from: location }}
      />
    );
  }

  return <>{children}</>;
};
